import { ReactNode } from "react";
import { LoadingSpinner, LoadingSpinnerSize } from "../LoadingSpinner"

interface LoadingWrapperProps {
    children: ReactNode;
    loading: boolean;
    spinnerSize?: LoadingSpinnerSize;
}

/**
 * Simple loading wrapping for any component. Simply pass in a boolean
 * to indicate if the child component is loading, and this wrapper will 
 * show a spinner instead of rendering its children .
 */
export const LoadingWrapper = (props: LoadingWrapperProps) => {
    return (
        <>
            {props.loading ? <LoadingSpinner size={props.spinnerSize ?? LoadingSpinnerSize.Medium} /> : props.children}
        </>
    );
}